import React from 'react';

/**
 * A panel's title and one-line description, rendered at the top of the panel
 * (inside its card) so a reader can tell at a glance what the panel is for. Kept
 * small and muted — the panel's own content stays the focus.
 *
 * @param {string} props.title
 * @param {string} props.description
 * @param {"default"|"onColor"|"onTint"} [props.variant] "onColor" renders light text
 *   for a filled coloured surface; "onTint" keeps the dark text but uses a brand-tinted
 *   divider so the separator is visible on the soft-tint timer card (a gray divider
 *   washes out on the blue); default is the muted text + gray divider for a white card.
 */
export default function PanelHeading({ title, description, variant = 'default' }) {
  const onColor = variant === 'onColor';
  const onTint = variant === 'onTint';
  const border = onColor
    ? 'border-white/20'
    : onTint
      ? 'border-[#32B1FF]/25'
      : 'border-gray-100 dark:border-gray-800';
  return (
    <div className={`mb-3 border-b pb-3 ${border}`}>
      <h2 className={`text-sm font-semibold ${onColor ? 'text-white' : 'text-gray-900 dark:text-gray-100'}`}>{title}</h2>
      <p className={`mt-0.5 text-xs ${onColor ? 'text-white/75' : 'text-gray-500 dark:text-gray-400'}`}>{description}</p>
    </div>
  );
}
